const Mediator = {
  events: {},

  on: (eventName, fn) => {
    Mediator.events[eventName] = Mediator.events[eventName] || [];
    Mediator.events[eventName].push(fn);
  },

  off: (eventName, fn) => {
    if (Mediator.hasEventName(eventName)) {
      const found = Mediator.events[eventName].indexOf(fn);

      if (found !== -1) {
        Mediator.events[eventName].splice(found, 1);
      }
    }
  },

  find: (eventName, fn) => {
    if (Mediator.hasEventName(eventName)) {
      return Mediator.events[eventName].indexOf(fn) !== -1;
    }
  },

  emit: (eventName, data) => {
    if (Mediator.hasEventName(eventName)) {
      const eventList = Mediator.events[eventName];

      for (let i = eventList.length - 1; i >= 0; i--) {
        if (typeof eventList[i] === "function") {
          eventList[i](data);
        }
      }
    }
  },

  hasEventName: (eventName) => {
    return Mediator.events.hasOwnProperty(eventName);
  },

  destroy: () => {
    Mediator.events = {};
  },
};

export default Mediator;
